"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenAeSchema = void 0;
const shouldRenderProperty_1 = require("./shouldRenderProperty");
const Localization_utils = require("../../../localization-utils");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const dotty = require('dotty');
/**
 * Recursively iterates through a property's schema, flattening all objects/arrays and creating a single array of Subsections
 * @param {AeSchema | PropertySchema} aeSchema Either a schema for a FORM or a schema for an ACTION
 * @param {string[]} propertyAccessor The names of the sub-properties that are stepped through to get to this property. I.e., given the actionSchema of: {properties: {activities: {properties: {question1: {...}}}}}, you would pass ["activities", "question1"] to access question1.
 * @param {string} actionType The key for the action related to this property
 * @param {string} language The language which will be used for the export
 *
 * @returns {ColumnSchema[]} An array of ColumnSchemas which can be used to create a SheetSchema
 */
function flattenAeSchema(aeSchema, propertyAccessor, options) {
    if (!propertyAccessor.length)
        throw new Error(`flattenAeSchema received an invalid propertyAccessor with value ${propertyAccessor}`);
    const subsections = [];
    const language = (options === null || options === void 0 ? void 0 : options.language) || 'en';
    const propertySchema = dotty.get(aeSchema, propertyAccessor);
    if (propertySchema == undefined)
        return [];
    // Add new columns
    if ((0, shouldRenderProperty_1.shouldRenderProperty)(propertySchema)) {
        if (!(options === null || options === void 0 ? void 0 : options.hideLocalizedData)) {
            subsections.push({
                subtitle: Localization_utils.propertyTypeToHeader(aeSchema, propertyAccessor, false, language),
                dataAccessor: propertyAccessor.filter((accessor) => accessor !== 'properties' && accessor !== 'schema'),
                displayType: propertySchema.displayType,
                inputType: propertySchema.inputType,
                propertyAccessor,
                raw: false,
            });
        }
        if (options === null || options === void 0 ? void 0 : options.showRawData) {
            subsections.push({
                subtitle: Localization_utils.propertyTypeToHeader(aeSchema, propertyAccessor, true, language),
                dataAccessor: propertyAccessor.filter((accessor) => accessor !== 'properties' && accessor !== 'schema'),
                displayType: propertySchema.displayType,
                inputType: propertySchema.inputType,
                propertyAccessor,
                raw: true,
            });
        }
    }
    // Recurse if there are subkeys
    if (typeof propertySchema === 'object' &&
        !Array.isArray(propertySchema) &&
        propertySchema !== null) {
        Object.keys(propertySchema).forEach((subProperty) => {
            const deeperPropertyAccessor = propertyAccessor.concat(subProperty);
            const recurseColumns = flattenAeSchema(aeSchema, deeperPropertyAccessor, options);
            subsections.push(...recurseColumns);
        });
    }
    return subsections;
}
exports.flattenAeSchema = flattenAeSchema;
//# sourceMappingURL=flattenAeSchema.js.map